import React, { use, useEffect, useState } from 'react'
import { Container, Row, Col, Modal, Button, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../components/auth/useAuth'
import { getUsers, addUser, editUser, enableUser, disableUser } from '../../actions/auth/usersActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../components/loaders/Loader'
import UserForm from '../../components/forms/UserForm'

export default function Users() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState(0)

    const {user, users, resultuser, loading, total} = useSelector(state=>state.users)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({roles: ['technical', 'breeder']})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)

    useEffect(() => {
        if(clientauth){
            dispatch(getUsers(page, limit, search))
        }
    },[dispatch, t, clientauth])

    useEffect(() => {
        if (clientauth) {
            dispatch(getUsers(page, limit, search))
        }
    }, [page, limit, search])

    const openModal = () =>{
        setIsAddingOrEditing('adding')
        setFormState({roles: ['technical', 'breeder']})
        setModalShow(true)
    }

    const selectUser = (user) => {
        setFormState({...user, 'password': ''})
        setIsAddingOrEditing('editing')
        setModalShow(true)
    }

    const handleInputChange = ({target})=>{
        if(target.name === 'province'){
            setFormState({
                ...formState,
                'province': target.value,
                'town': ''
            })
        }else{
            setFormState({
                ...formState,
                [target.name]: target.value
            })
        }
    }

    const handleSubmit= async(e) => {
        e.preventDefault()
        setIsRegistering(true)

        if(isAddingOrEditing==='editing'){
            dispatch(editUser(formState, formState._id))
        }else{
            dispatch(addUser(formState))
        }
        setIsRegistering(false)
    }

    const disableEnableUser = async(e) => {
        e.preventDefault()
        let textQuestion = formState.active ?
            t('admin.user.areyousuredisable')+'<br><p><label className="fs-20 fw-600 pt-5">'+formState?.name+'</label></p>'
        :
            t('admin.user.areyousureenable')+'<br><p><label className="fs-20 fw-600 pt-5">'+formState?.name+'</label></p>'

        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.accept'),
            denyButtonText: t('global.cancel'),
            html: textQuestion
        }).then((result) => {
            if (result.isConfirmed) {
                if (formState.active) {
                    dispatch(disableUser(formState._id))
                }else{
                    dispatch(enableUser(formState._id))
                }
            }
        })
    }

    useEffect(() => {
        if(resultuser){
            let resultusernow = resultuser
            dispatch({ type: 'USER_RESET_RESULT' })
            switch (resultusernow) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.user.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'email':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'warning',
                        text: t('admin.user.emailduplicated')
                    })
                    break;
                case 'needMoreData':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.ok'),
                        icon: 'warning',
                        text: t('admin.user.needMoreData')
                    })
                    break;
                case 'editSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.user.editSuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultuser])

    const columnsUser = [
        {
            name: t('admin.user.email'),
            cell: user =>
                <div className='cursor' onClick={() => selectUser(user)}>
                    {user.email}
                </div>,
            selector: (user) => user.email,
            sortable: true,
        },{
            name: t('admin.user.name'),
            cell: user =>
                <div className='cursor' onClick={() => selectUser(user)}>
                    {user.name}
                </div>,
            selector: (user) => user.name,
            sortable: true,
        },{
            name: t('admin.user.active'),
            width: '100px',
            cell: user =>
                <div>
                    {user.active
                        ?
                            <img src="../images/check.svg" alt="check" width={25}></img>
                        :
                            <img src="../images/times.svg" alt="times" width={25}></img>
                    }
                </div>,
            selector: (user) => user.active,
            sortable: true,
        },{
            name: '',
            width: '100px',
            cell: user =>
                <div className='cursor' onClick={() => selectUser(user)}>
                    <i className='fas fa-pencil'></i>
                </div>,
            sortable: false,
        }
    ]

    return (
        <Container className='p-5'>
            <Row>
                <Col xs={12}>
                    <h1>{t('admin.user.users')}</h1>
                </Col>
                <Col xs={12} className='d-flex justify-content-end'>
                    <Button variant='primary' type="submit" className="my-2 cursor" onClick={() => openModal()}>
                        <i className="fas fa-plus me-2"></i>  {t('admin.user.createuser')}
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className='my-3'>
                    {loading ?
                        <Loader/>
                    :
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-flex my-2">
                                            <input
                                                type="text"
                                                className="form-control me-2"
                                                placeholder={t("datatables.buscar")}
                                                value={searchAux || ""}
                                                onChange={e => {
                                                    setSearchAux(e.target.value);
                                                    setPage(1);
                                                }}
                                                onKeyDown={(e) => {if (e.key === 'Enter') { setSearch(searchAux); setPage(1); }}}
                                            />
                                            <Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                                        </div>
                                        {users?.length > 0 ?
                                            <CustomDataTable
                                                columns={columnsUser}
                                                data={users}
                                                pagination
                                                paginationServer
                                                paginationTotalRows={totalRows}
                                                searchText={search}
                                                onChangeRowsPerPage={(newLimit, page) => {
                                                    if (limit !== newLimit) {
                                                        setLimit(newLimit)
                                                        setPage(1)
                                                    }
                                                }}
                                                onChangePage={(newPage) => {
                                                    setPage(newPage)
                                                }}
                                            />
                                        :
                                            <h4 className='mt-4'>{t('admin.user.thereisnotuser')}</h4>
                                        }
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t('admin.user.user')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <UserForm
                        state={formState}
                        usertype={'admin'}
                        handleInputChange={handleInputChange}
                        submit={handleSubmit}
                        disableEnableUser={disableEnableUser}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                    />
                </Modal.Body>
            </Modal>
        </Container>
    )
}